export default __webpack_public_path__ + "static/media/Sorcerer's Helm of the Mandate.3bbc7562.jpg";